// JWT constants
export const FETCH_JWT_DATA = "FETCH_JWT_DATA";
export const FETCH_JWT_DATA_LOADING = "FETCH_JWT_DATA_LOADING";
export const FETCH_JWT_DATA_ERROR = "FETCH_JWT_DATA_ERROR";
export const JWT_EXPIRED_OR_INVALID = "JWT_EXPIRED_OR_INVALID";

// User constants
export const FETCH_USER_DATA = "FETCH_USER_DATA";
export const FETCH_USER_REAL_DATA = "FETCH_USER_REAL_DATA";
export const FETCH_USER_DATA_TOHOME = "FETCH_USER_DATA_TOHOME";
export const FETCH_USER_DATA_LOADING = "FETCH_USER_DATA_LOADING";
export const FETCH_USER_DATA_ERROR = "FETCH_USER_DATA_ERROR";
export const REFRESH_TOKEN_INTERVAL_ID = "REFRESH_TOKEN_INTERVAL_ID";

// Project constants
export const FETCH_PROJECT_DATA = "FETCH_PROJECT_DATA";
export const FETCH_PROJECT_DATA_TOTAL = "FETCH_PROJECT_DATA_TOTAL";
export const FETCH_PROJECT_DATA_LOADING = "FETCH_PROJECT_DATA_LOADING";
export const FETCH_PROJECT_DATA_ERROR = "FETCH_PROJECT_DATA_ERROR";

// Profile constants
export const FETCH_PROFILE_DATA = "FETCH_PROFILE_DATA";
export const FETCH_PROFILE_DATA_TOTAL = "FETCH_PROFILE_DATA_TOTAL";
export const FETCH_PROFILE_DATA_LOADING = "FETCH_PROFILE_DATA_LOADING";
export const FETCH_PROFILE_DATA_ERROR = "FETCH_PROFILE_DATA_ERROR";

// Layout constants
export const FETCH_LAYOUT_DATA = "FETCH_LAYOUT_DATA";
export const FETCH_LAYOUT_DATA_LOADING = "FETCH_LAYOUT_DATA_LOADING";
export const FETCH_LAYOUT_DATA_ERROR = "FETCH_LAYOUT_DATA_ERROR";

// Classes constants
export const FETCH_CLASS_DATA = "FETCH_CLASS_DATA";
export const FETCH_CLASS_DATA_LOADING = "FETCH_CLASS_DATA_LOADING";
export const FETCH_CLASS_DATA_ERROR = "FETCH_CLASS_DATA_ERROR";

// Styles constants
export const FETCH_STYLE_DATA = "FETCH_STYLE_DATA";
export const FETCH_STYLE_DATA_LOADING = "FETCH_STYLE_DATA_LOADING";
export const FETCH_STYLE_DATA_ERROR = "FETCH_STYLE_DATA_ERROR";

// SymStyle constants
export const FETCH_SYMSTYLE_DATA = "FETCH_SYMSTYLE_DATA";
export const FETCH_SYMSTYLE_DATA_LOADING = "FETCH_SYMSTYLE_DATA_LOADING";
export const FETCH_SYMSTYLE_DATA_ERROR = "FETCH_SYMSTYLE_DATA_ERROR";

// UserTeam constants
export const FETCH_USERTEAM_DATA = "FETCH_USERTEAM_DATA";
export const FETCH_MEMBERTEAM_DATA = "FETCH_MEMBERTEAM_DATA";
export const FETCH_USERTEAM_DATA_LOADING = "FETCH_USERTEAM_DATA_LOADING";
export const FETCH_USERTEAM_DATA_ERROR = "FETCH_USERTEAM_DATA_ERROR";
export const FETCH_USERTEAM_DATA_COMPLETED = "FETCH_USERTEAM_DATA_COMPLETED";

// Filter constants
export const FILTER_PROJECT_MODE = "FILTER_PROJECT_MODE";
export const FILTER_PROJECT_VALUE = "FILTER_PROJECT_VALUE";
export const FILTER_PROJECT_PAGINATION_PAGE = "FILTER_PROJECT_PAGINATION_PAGE";
export const FILTER_PROFILE_PAGINATION_PAGE = "FILTER_PROFILE_PAGINATION_PAGE";

// Chapter constants
export const FETCH_CHAPTER_DATA = "FETCH_CHAPTER_DATA";
export const FETCH_CHAPTER_DATA_CONTENT = "FETCH_CHAPTER_DATA_CONTENT";
export const FETCH_CHAPTER_DATA_CONTENT_ALT = "FETCH_CHAPTER_DATA_CONTENT_ALT";
export const FETCH_CHAPTER_DATA_ROW = "FETCH_CHAPTER_DATA_ROW";
export const FETCH_CHAPTER_DATA_TYPO = "FETCH_CHAPTER_DATA_TYPO";
export const FETCH_CHAPTER_DATA_LOADING = "FETCH_CHAPTER_DATA_LOADING";
export const FETCH_CHAPTER_DATA_ERROR = "FETCH_CHAPTER_DATA_ERROR";

// Typo constants
export const TYPO_SELECTED_IMGSIZE = "TYPO_SELECTED_IMGSIZE";

// CardUI constants
export const CARDUI_NAVBARCARD = "CARDUI_NAVBARCARD";
export const CARDUI_VISIBILITY_IMGALT = "CARDUI_VISIBILITY_IMGALT";
export const CARDUI_SELECTED_PROJECT = "CARDUI_SELECTED_PROJECT";
export const CARDUI_SEARCH_ISLOADING = "CARDUI_SEARCH_ISLOADING";
export const CARDUI_COPYPASTE = "CARDUI_COPYPASTE";

// CardUI save project constants
export const CARDUI_SAVE_PROJECT_COMPLETED = "CARDUI_SAVE_PROJECT_COMPLETED";
export const CARDUI_SAVE_PROJECT_LOADING = "CARDUI_SAVE_PROJECT_LOADING";
export const CARDUI_SAVE_PROJECT_ERROR = "CARDUI_SAVE_PROJECT_ERROR";

// Watermark constants
export const FETCH_WATERMARK_DATA = "FETCH_WATERMARK_DATA";
export const FETCH_WATERMARK_DATA_LOADING = "FETCH_WATERMARK_DATA_LOADING";
export const FETCH_WATERMARK_DATA_ERROR = "FETCH_WATERMARK_DATA_ERROR";

// Error constants
export const CURRENT_ERROR = "CURRENT_ERROR";



// WEBPACK FOOTER //
// ./src/store/constants.js